import React, { useContext, useState } from 'react'
import { StyledBanner } from './EmailBanner.styled'
import { UserSettingsLink } from './UserSettingsLink'
import { tokens } from '@news-mono/design-tokens'
import { useSendVerifyEmail } from '../hooks/useSendVerifyEmail'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { useSelector } from 'react-redux'
import { AppState, Product } from '@news-mono/web-common'
import { useDebugQueryParams } from '../hooks/useDebugQueryParams'
import { PNToastComponent } from '../../content'
import { useProduct } from '../../__product'

// TheNightly Colors
const tnColors = tokens.thenightly.colors
const tnPalette = tnColors.palette

export const EmailBanner = () => {
    const { wanUserId, auth0UserId, emailVerified } = useSelector(
        (state: AppState) => state.authentication,
    )
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const ctx = useContext(MyAccountContext)
    const debugParams = useDebugQueryParams()
    const product = useProduct()
    let isEmailVerified = emailVerified

    if (debugParams.emailVerified !== null) {
        isEmailVerified = debugParams.emailVerified
    }

    // Utilise debug params as a forefront state check
    const showBanner =
        debugParams.emailBanner ||
        (!isEmailVerified && ctx.screen !== 'verify-email')
    const { mutateAsync: sendEmail } = useSendVerifyEmail(
        auth0UserId || wanUserId,
    )

    async function sendVerifyEmail() {
        if (isLoading) return
        setIsLoading(true)
        const response = await sendEmail()

        if (response) {
            ctx.setScreenSelected(true)
            ctx.setScreen('verify-email')
        } else {
            ctx.setMessageBanner({
                text: 'Failed to send email, please try again later.',
                type: 'error',
            })
        }
        setIsLoading(false)
    }

    const Component =
        product === Product.PerthNow
            ? PerthNowEmailBanner
            : TheNightlyEmailBanner

    return showBanner ? <>{Component(sendVerifyEmail)}</> : null
}

const PerthNowEmailBanner = (sendVerifyEmail: () => void) => {
    return (
        <PNToastComponent
            type={'verify'}
            text={
                <>
                    Verify your account to unlock full access.{' '}
                    <a
                        tabIndex={0}
                        onClick={sendVerifyEmail}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                sendVerifyEmail()
                            }
                        }}
                    >
                        Resend verification email
                    </a>
                </>
            }
            useMaxWidth={false}
            forceMaxWidth={true}
        />
    )
}
const TheNightlyEmailBanner = (sendVerifyEmail: () => void) => {
    return (
        <StyledBanner>
            <p>
                Verify your account to unlock full access. &nbsp;
                <UserSettingsLink
                    color={tnPalette.starlight.default}
                    onClick={sendVerifyEmail}
                    fontWeight={400}
                    display="block"
                >
                    Resend verification email
                </UserSettingsLink>
            </p>
        </StyledBanner>
    )
}
